import { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Jumbotron from 'react-bootstrap/Jumbotron';
import Table from 'react-bootstrap/Table';
import SearchProducts from '../components/SearchProducts';
import AuthContext from '../contexts/AuthContext';
import getProductCollections from '../utils/getProductCollections';

export const HomePage = () => {
  const history = useHistory(); // for routing
  const { authState } = useContext(AuthContext);

  const [productCollections, setProductCollections] = useState([]);
  useEffect(() => {
    async function fetchData() {
      // XXX: get all available collections and search for searchString
      const userPermissions = authState?.userPermissions;
      const usersCollections = Object.keys(userPermissions);
      const productCollections = await getProductCollections(usersCollections);
      setProductCollections(productCollections);
    }
    fetchData();
  }, [authState?.userPermissions]);

  return (
    <Jumbotron>
      <h1>Welcome to the FaceCake Asset Lab</h1>
      <p>
        Please enter a product SKU to search or select an available product category to start browsing products.
      </p>
      <div>
        <SearchProducts />
      </div>
      <Table size="sm" hover striped>
        <thead>
          <tr>
            <th>Collection</th>
            <th>Product Type</th>
          </tr>
        </thead>
        <tbody>
          { (productCollections?.length > 0)
            ?
            productCollections?.map(productCollection => {
            // HACK: skip if collection is ebay
            if (Object.keys(productCollection)[0] === 'ebay') return;
            const collection = Object.keys(productCollection)[0];
            return productCollection[collection]?.productTypes.map(productType => {
              return (
                <tr key={`${collection}/${productType}`} className="product-category-row" onClick={() => history.push(`/products/${collection}/${productType}/`)}>
                  <td>{ collection.toUpperCase() }</td>
                  <td>{ productType.toUpperCase() }</td>
                </tr>
              );
            })})
            :
            <tr>
              <td colSpan={2} className="text-center py-5">
                <Button variant="primary" onClick={() => document.location = '/home'}>Get Products</Button>
              </td>
            </tr>
          }
        </tbody>
      </Table>
    </Jumbotron>
  );
}
